import React, {useState} from 'react';
import styles from './styles';
import {InOutAnimation as Animation} from '@xpertdox_js/xdcomponents';
import animations from './Hooks/animations';
import DisplayField from './DisplayField';

const EditableField = props => {
  // console.log('OverviewContainer/EditableField props', props)
    // -- refs/vars
    const initialLoad = React.useRef(true);
    const type = props.type || 'text';
    // track whether this component has an 'instant' edit state
    const simpleComponentFieldTypes = ['text', 'textarea'];
    const isSimpleComponent = props.settings.customEditField  ? false
    : (props.isSimpleComponent || simpleComponentFieldTypes.includes(type));

    // -- state
    const [hover, setHover] = useState(false);
    const [showCustom, setShowCustom] = useState(false);
    const [state, setState] = useState(() => 'display');
    const [minfieldheight, setminfieldheight] = useState(null);
    if (props.state && props.state !== state) setState(props.state);
    const {settings} = props;
    const isEditable = settings.editable === undefined || settings.editable !== false;
    // -- dynamic styles
    let itemStyles = (hover || state === 'edit')
    ? {...styles.editSection, ...styles.editSectionHov, cursor: isEditable ? 'pointer' : null}
    : {...styles.editSection, cursor: isEditable ? 'pointer' : null};
    itemStyles.width = props.width;

    // -- value state
    const [valueState, setValueState] = useState(
      props.diff
      || settings.value
      || (isSimpleComponent ? '' : undefined)
    );
    const updateValueState = (value, clear=false) => {
      const formattedValue = value === 'custom-null' ? null : value;
      // console.log(formattedValue, "VLUE")
      setValueState(formattedValue);
      if (!clear && value !== settings.value) props.setValue(settings.diffProperty, value)
      else props.setValue(settings.diffProperty, null);
    }

    // -- change display state
    const changeState = value => {
      if (initialLoad.current) initialLoad.current = false;
      setState(value);
    }

    // -- construct field wrapper element
    const FieldWrap = 'div';
    let fieldProps = {};
    const getFieldProps = (initial, stateID, animationSetting) => {
      // const editRoute = stateID === 'display' ? e => changeState('edit') : undefined;
      const editRoute = () => changeState('edit');
      // if (!initial && !isSimpleComponent) return {
      //   animation: animationSetting || animations.toEdit,
      //   condition: state === stateID,
      //   wrapStyles: {...styles.contentWrap, width: props.width || '100%'},
      //   alwaysRender: true,
      //   wrapperProps: {
      //     onClick: isEditable && state === 'display' ? editRoute : null
      //   }
      // };
      return {
        style: {...styles.contentWrap, width: props.width || '100%'},
        onClick: isEditable && state === 'display' ? editRoute : null,
      };
    }

    // -- track height of the current display for smooth transitions
    const [fieldHeight, setFieldHeight] = useState(null);
    const handleHeight = (stateID, node, minHeight) => {
      if (node && state === stateID) {
        let measureHeight = minHeight && node.clientHeight < minHeight ? minHeight : node.clientHeight;
        if (fieldHeight !== measureHeight) setFieldHeight(measureHeight);
      }
    }
    // -- add dynamic styles
    if (fieldHeight) itemStyles = {
      ...itemStyles,
      height: fieldHeight + 'px',
      maxHeight: fieldHeight + 'px'
    }
    if (props.zIndex !== undefined) itemStyles.zIndex = props.zIndex;
    //Add 24 (padding buffer) to height
    if (state === 'edit') itemStyles = {
      ...itemStyles,
      height: fieldHeight+24+'px',
      maxHeight: fieldHeight+24+'px',
      zIndex: 10+props.zIndex
    }
    itemStyles.overflow = state === 'edit' ? 'visible' : 'hidden';

    // if(props.settings.diffProperty === 'minAge') console.log(props,"props")
    return(
      <div
        style={props.index === props.length
          ? {...itemStyles, borderBottom: 0}
          : itemStyles}
        onMouseOver={isEditable ? e => setHover(true) : null}
        onMouseLeave={isEditable ? e => setHover(false) : null}
      >
      <div style={{...styles.fieldContainer, width: parseInt(props.width) ? parseInt(props.width) * 3 + 'px' : '100%'}}>
        <FieldWrap
          {...getFieldProps(initialLoad.current, 'display')}
          key={'display'}
        >
          <DisplayField
            state={state}
            minfieldheight={minfieldheight}
            setminfieldheight={setminfieldheight}
            isSimpleComponent={isSimpleComponent}
            customEditField={settings.customEditField}
            customDisplayField={settings.customDisplayField}
            clearCallback={settings.clearChangesCallback}
            hover={hover}
            valueState={valueState}
            setValueState={updateValueState}
            formSettings={settings.formSettings}
            type={type}
            settings={settings}
            changeState={changeState}
            condition={state === 'display'}
            width={props.width}
            handleHeight={handleHeight}
            height={fieldHeight}
            editable={settings.editable}
            toolTip={settings.tooltip}
          />
        </FieldWrap>
        <FieldWrap
          {...getFieldProps(initialLoad.current, 'edit', animations.toDisplay)}
          minfieldheight={minfieldheight}
          key={'edit'}
        >
        </FieldWrap>
      </div>
      </div>
  )
}

export default EditableField;
